export enum VerificationRequestGroup {
  employers = 'Employers',
  peo = 'PEOs',
  peoPayrollProvider = 'PEO Payroll Providers',
}

export enum DashboardRevenueShareDimensions {
  month = 'month',
  revenueSharePayedAmount = 'revenueSharePayedAmount',
  type = 'type',
}
